import { ROUTE_NAME, RouteFeatures, SupportedPath } from '../types';

export const getSupportedPaths = (features: RouteFeatures): SupportedPath[] => {
  const { isAccountSettingsIndexEnabled } = features;
  const paths = [];

  if (isAccountSettingsIndexEnabled) {
    paths.push(
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/email',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/notifications',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/watched/repositories/',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/watched/pull-requests/',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/watched/issues/',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/watched/snippets/',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/app-authorizations',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/app-passwords',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/app-passwords/new',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/ssh-keys',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/two-step-verification',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/security/sessions',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/auditlog',
        exact: true,
      },
      {
        name: ROUTE_NAME.ACCOUNT_SETTINGS_IFRAME,
        path: '/account/settings/features/',
        exact: true,
      }
    );
  }

  return paths;
};
